import Swiper from 'swiper/bundle'
import $ from 'jquery'

export default class {
  constructor(element) {
    if (!element) {
      return false
    }

    this.wrap = jQuery(element)
    this.slider = this.wrap.find('.s-gallery__items')
    this.next = this.wrap.find('.swiper-button-next')
    this.prev = this.wrap.find('.swiper-button-prev')
    this.pagination = this.wrap.find('.swiper-pagination')

    this._iniSlider()
    console.log('this.wrap', this.wrap, this.slider)

    $(window).on('resize', () => {
      this._iniSlider()
    })
  }

  _iniSlider() {
    var isMobile = window.matchMedia('(max-width: 767px)').matches

    var swiperOptions = {
      spaceBetween: 32,
      slidesPerView: 'auto',
      navigation: {
        nextEl: this.next[0],
        prevEl: this.prev[0],
      },
      pagination: {
        clickable: true,
        el: this.pagination[0],
      },
      breakpoints: {
        320: {
          spaceBetween: 12,
        },
        780: {
          spaceBetween: 32,
        },
      },
    }

    if (isMobile) {
      swiperOptions.autoplay = {
        delay: 4000,
        disableOnInteraction: false,
      }
    }

    if (this.swiper) {
      this.swiper.destroy(true, true) // Destroy the existing Swiper instance
    }

    this.swiper = new Swiper(this.slider[0], swiperOptions)
  }
}
